import { onMounted, onUnmounted } from 'vue'
import Lenis from 'lenis'

export function useLenis() {
  let lenis = null

  onMounted(() => {
    // Inicializar Lenis
    lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
    })

    // Función de animación
    function raf(time) {
      lenis.raf(time)
      requestAnimationFrame(raf)
    }

    requestAnimationFrame(raf)

    // Exponer lenis globalmente para GSAP ScrollTrigger si se necesita
    window.lenis = lenis
  })

  onUnmounted(() => {
    if (lenis) {
      lenis.destroy()
      window.lenis = null
    }
  })

  return {
    lenis,
  }
}
